import { useEffect, useRef, useState } from 'react';
import EditableCell from './EditableCell';
import constant, { BusinessStatus, BusinessStatusColor, generateColorWithShades } from '../../../../helper/constant';
import AddBusinessCellModal from './AddBusinessCellModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faEye, faEyeSlash, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../../context/app.context';

// Helper functions to compute row spans
const getCompanyRowSpan = (company) =>
    company.products?.reduce((sum, prod) => sum + getProductRowSpan(prod), 0);

const getProductRowSpan = (product) =>
    product.opportunities?.reduce((sum, opp) => sum + getOpportunityRowSpan(opp), 0);

const getOpportunityRowSpan = (opp) =>
    opp.recommendations?.reduce((sum, rec) => sum + (rec.showMore ? rec.sub_tasks?.length : constant.default360SubTaskRowDisplay) || 0, 0);

export const ADD_CELL_MODAL_TYPE = {
    PRODUCT: 'product',
    OPPERTUNITY: 'opportunity',
    RECOMMENDATION: 'recommendation',
    CLINET: 'client',
    SUB_TASK: 'sub_task'
}

const ResizableTable = () => {
    const tableRef = useRef(null);
    const [modal, setModal] = useState({ show: false, data: {}, type: '' });
    const { business360EditMode, business360Data } = useAppContext();

    useEffect(() => {
        const table = tableRef.current;
        const thEls = table.querySelectorAll("th");

        thEls.forEach((th) => {
            const resizer = document.createElement("div");
            resizer.classList.add("resizer");
            th.appendChild(resizer);

            let startX, startWidth;

            resizer.addEventListener("mousedown", (e) => {
                startX = e.clientX;
                startWidth = th.offsetWidth;

                const handleMouseMove = (e) => {
                    const newWidth = startWidth + (e.clientX - startX);
                    th.style.width = `${newWidth}px`;
                };

                const handleMouseUp = () => {
                    document.removeEventListener("mousemove", handleMouseMove);
                    document.removeEventListener("mouseup", handleMouseUp);
                };

                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
            });
        });
    }, []);

    const onAddCell = (type) => {
        setModal({
            show: true,
            type
        });
    }

    const renderRenderAddCellModal = () => {
        return <AddBusinessCellModal
            type={modal.type}
            businessData={business360Data[0]}
            showModal={modal.show}
            setShowModal={flag => setModal({ show: flag })} />
    }

    const renderActionTableHeader = (lable, type) => {
        return (
            <div className='position-relative'>
                <p className='p-0 m-0'>{lable}</p>
                {business360EditMode && <button className='btn btn-clear position-absolute p-0 m-0' style={{ top: -30, right: -5 }}
                    onClick={() => onAddCell(type)}><FontAwesomeIcon icon={faPlusCircle} className='text-white' /></button>}
            </div>
        )
    }

    const renderTableHeader = () => {
        return (
            <thead>
                {/*  Main header 1 */}
                {/* <tr className="main-header">
                    <th style={{ backgroundColor: '#795500' }} colSpan="29">Exploration</th>
                    <th style={{ backgroundColor: '#533a00' }} colSpan="39">Exploitation</th>
                </tr> */}
                {/*  Main header 2 */}
                <tr className="main-header">
                    <th style={{ background: 'linear-gradient(90deg, #412460, #1168C5', borderRight: '1px solid' }} colSpan="10">Innovation Flow </th>
                    <th style={{ background: 'linear-gradient(90deg, #1168C5, #439F66', borderRight: '1px solid' }} colSpan="19">Product Flow</th>
                    <th style={{ background: 'linear-gradient(90deg, #439F66, #9C9C64', borderRight: '1px solid' }} colSpan="17">Market Flow</th>
                    <th style={{ background: 'linear-gradient(90deg, #9C9C64, #9D57CD' }} colSpan="22">Customer Flow</th>
                </tr>

                {/* Sub header */}
                <tr className="sub-header">
                    <th colSpan="4" className="">Strategic plan</th>
                    <th colSpan="6" className="" style={{ borderRight: '1px solid' }}>Financials</th>
                    <th colSpan="1" className="">People Management</th>
                    <th colSpan="1" className="">Sub Tasks</th>
                    <th colSpan="5" className="">Development Plan / Status</th>
                    <th colSpan="6" className="">Supply Chain</th>
                    <th colSpan="6" className="" style={{ borderRight: '1px solid' }}>Operations and QA</th>
                    <th colSpan="9" className="">Product Marketing Plan/ Status </th>
                    <th colSpan="5" className="">Communication Marketing Plan</th>
                    <th colSpan="3" className="" style={{ borderRight: '1px solid' }}>IT Security and Risk</th>
                    <th colSpan="1" className="">Clients</th>
                    <th colSpan="5" className="">Sales Funnel</th>
                    <th colSpan="6" className="">Delivery</th>
                    <th colSpan="3" className="">Accounting</th>
                    <th colSpan="3" className="">Customer Experience</th>
                    <th colSpan="4" className="">Upsell</th>
                </tr>

                {/* Small headers */}
                <tr className="small-header">
                    {/*Strategic plan */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Company</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>
                        {renderActionTableHeader('Product/Service', ADD_CELL_MODAL_TYPE.PRODUCT)}
                    </th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>
                        {renderActionTableHeader('Opportunities & Threats', ADD_CELL_MODAL_TYPE.OPPERTUNITY)}</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>
                        {renderActionTableHeader('Recommendations', ADD_CELL_MODAL_TYPE.RECOMMENDATION)}</th>
                    {/*Financials*/}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Cost</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Benefit</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>NPV</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Timeline</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Chart</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Grants</th>
                    {/*People managent */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>People Management</th>
                    {/*Subtask*/}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>{renderActionTableHeader('Sub Tasks', ADD_CELL_MODAL_TYPE.SUB_TASK)}</th>
                    {/* Development Plans */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Document</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Design</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Develop</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Test</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Approve</th>
                    {/* Supply Plan */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Search</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Align</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Plan</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Procure</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Execute</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Replenish</th>
                    {/* Operations */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Scope</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Define</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Asemble</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Validate</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>QA</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Monitor</th>
                    {/* Product Marketing Plan */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Ideal Customer Profile</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Budget</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Core Value</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Positioning</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Message</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>4P's</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Channel Choice Calculator</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Launch & Gather Feedback</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Refine</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Plan Alignment</th>
                    {/* Communication Marketing Plan */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Customer Journey</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Design Sales playbook</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Marketing Collateral</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Run Campaign</th>
                    {/* IT Security */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>IT</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Security Protocols</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Risks and Mitigation</th>
                    {/* Clients */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>{renderActionTableHeader('Clients', ADD_CELL_MODAL_TYPE.CLINET)}</th>
                    {/* Sales */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Lead Awareness</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Interest</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Decision</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Action</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Expand</th>
                    {/* Delviery  */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Delivery Approach</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Resource planning</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Schedule</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Ship</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Deliver</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Install</th>
                    {/* Accounting */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Invoice</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Processing</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Posting</th>
                    {/* Customer Experience */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Journey Map</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Execute</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Evolve</th>
                    {/* Future Marketing */}
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Plan</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Execute</th>
                    <th style={{ backgroundColor: BusinessStatusColor.DARK_GRAY }}>Evolve</th>
                </tr>
            </thead>
        );
    }

    const renderFinancials = (financial, recSpan, backgroundColor, reference, show) => {
        return (
            <>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={financial?.cost} reference={{ ...reference, key: 'financial.cost' }} show={show} /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={financial?.benefit} reference={{ ...reference, key: 'financial.benefit' }} show={show} /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={financial?.nvp} reference={{ ...reference, key: 'financial.nvp' }} show={show} /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={financial?.timeline} reference={{ ...reference, key: 'financial.timeline' }} show={show} /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={'TBD'} show={false} /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={financial?.grant?.recommended_grant} reference={{ ...reference, key: 'financial.grant.recommended_grant' }} show={show} /></td>
            </>
        )
    }

    const renderPeopleManagement = (people_management, recSpan, backgroundColor, reference, show) => {
        return (
            <><td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell value={people_management?.summary} reference={{ ...reference, key: 'people_management.summary' }} show={show} /></td></>
        )
    }



    const renderSubTasks = (sub_tasks, backgroundColor, reference, show, enableShowMore) => {

        return (
            <>
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell value={sub_tasks?.name} reference={{ ...reference, key: 'name' }} show={show} enableShowMore={enableShowMore} enableDelete enableSort type={ADD_CELL_MODAL_TYPE.SUB_TASK} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}>
                    <EditableCell
                        value={sub_tasks?.development_plan?.document.status} summary={sub_tasks?.development_plan?.document.summary} isStatus
                        reference={{ ...reference, key: 'development_plan.document.status' }} show={show} />
                </td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.development_plan?.develop.status} isStatus summary={sub_tasks?.development_plan?.develop.summary}
                    reference={{ ...reference, key: 'development_plan.develop.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.development_plan?.design.status} isStatus summary={sub_tasks?.development_plan?.design.summary}
                    reference={{ ...reference, key: 'development_plan.design.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.development_plan?.test.status} isStatus summary={sub_tasks?.development_plan?.test.summary}
                    reference={{ ...reference, key: 'development_plan.test.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.development_plan?.approve?.status} isStatus summary={sub_tasks?.development_plan?.approve.summary}
                    reference={{ ...reference, key: 'development_plan.approve.status' }} show={show} /></td>}
                {/* Supply chain */}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.search.status} isStatus summary={sub_tasks?.supply_chain?.search.summary}
                    reference={{ ...reference, key: 'supply_chain.search.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.align.status} isStatus summary={sub_tasks?.supply_chain?.align.summary}
                    reference={{ ...reference, key: 'supply_chain.align.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.plan.status} isStatus summary={sub_tasks?.supply_chain?.plan.summary}
                    reference={{ ...reference, key: 'supply_chain.plan.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.procure.status} isStatus summary={sub_tasks?.supply_chain?.procure.summary}
                    reference={{ ...reference, key: 'supply_chain.procure.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.execute.status} isStatus summary={sub_tasks?.supply_chain?.execute.summary}
                    reference={{ ...reference, key: 'supply_chain.execute.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.supply_chain?.replenish.status} isStatus summary={sub_tasks?.supply_chain?.replenish.summary}
                    reference={{ ...reference, key: 'supply_chain.replenish.status' }} show={show} /></td>}
                {/* Operations */}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.scope.status} isStatus summary={sub_tasks?.operations?.scope.summary}
                    reference={{ ...reference, key: 'operations.scope.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.define.status} isStatus summary={sub_tasks?.operations?.define.summary}
                    reference={{ ...reference, key: 'operations.define.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.assemble.status} isStatus summary={sub_tasks?.operations?.assemble.summary}
                    reference={{ ...reference, key: 'operations.assemble.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.validate.status} isStatus summary={sub_tasks?.operations?.validate.summary}
                    reference={{ ...reference, key: 'operations.validate.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.qa.status} isStatus summary={sub_tasks?.operations?.qa.summary}
                    reference={{ ...reference, key: 'operations.qa.status' }} show={show} /></td>}
                {<td rowSpan="1" style={{ backgroundColor }}><EditableCell
                    value={sub_tasks?.operations?.monitor.status} isStatus summary={sub_tasks?.operations?.monitor.summary}
                    reference={{ ...reference, key: 'operations.monitor.status' }} show={show} /></td>}
            </>
        )
    }

    const renderProductMarketPlan = (product_market_planning, recSpan, backgroundColor, reference, show) => {
        return (
            <>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.target_audience?.status} isStatus summary={product_market_planning?.target_audience?.summary}
                    reference={{ ...reference, key: 'product_market_planning.target_audience.status' }}
                    show={show}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.budget?.status} isStatus summary={product_market_planning?.budget?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.budget.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.core?.status} isStatus summary={product_market_planning?.core?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.core.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.positioning?.status} isStatus summary={product_market_planning?.positioning?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.positioning.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.message?.status} isStatus summary={product_market_planning?.message?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.message.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.four_p?.status} isStatus summary={product_market_planning?.four_p?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.four_p.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.channel_choice_calc?.status} isStatus summary={product_market_planning?.channel_choice_calc?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.channel_choice_calc.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.launch_gather_feedback?.status} isStatus summary={product_market_planning?.launch_gather_feedback?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.launch_gather_feedback.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={product_market_planning?.refine?.status} isStatus summary={product_market_planning?.refine?.summary}
                    show={show}
                    reference={{ ...reference, key: 'product_market_planning.refine.status' }}
                /></td>
            </>
        )
    }

    const renderCommuncationMarketPlan = (communication_market_planning, recSpan, backgroundColor, reference, show) => {
        return (
            <>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={communication_market_planning?.plan_alignment?.status} isStatus summary={communication_market_planning?.plan_alignment?.summary}
                    show={show}
                    reference={{ ...reference, key: 'communication_market_planning.plan_alignment.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={communication_market_planning?.strategy_market_plan?.status} isStatus summary={communication_market_planning?.strategy_market_plan?.summary}
                    show={show}
                    reference={{ ...reference, key: 'communication_market_planning.strategy_market_plan.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={communication_market_planning?.design_playbook?.status} isStatus summary={communication_market_planning?.design_playbook?.summary}
                    show={show}
                    reference={{ ...reference, key: 'communication_market_planning.design_playbook.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={communication_market_planning?.prepare_collateral?.status} isStatus summary={communication_market_planning?.prepare_collateral?.summary}
                    show={show}
                    reference={{ ...reference, key: 'communication_market_planning.prepare_collateral.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={communication_market_planning?.run_campaign?.status} isStatus summary={communication_market_planning?.run_campaign?.summary}
                    show={show}
                    reference={{ ...reference, key: 'communication_market_planning.run_campaign.status' }}
                /></td>
            </>
        )
    }

    const renderITSecurity = (it_security, recSpan, backgroundColor, reference, show) => {
        return (
            <>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={it_security?.it?.status} isStatus summary={it_security?.it?.summary}
                    show={show}
                    reference={{ ...reference, key: 'it_security.it.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={it_security?.security_protocol?.status} isStatus summary={it_security?.security_protocol?.summary}
                    show={show}
                    reference={{ ...reference, key: 'it_security.security_protocol.status' }}
                /></td>
                <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                    value={it_security?.risk_mitigation_plan?.status} isStatus summary={it_security?.risk_mitigation_plan?.summary}
                    show={show}
                    reference={{ ...reference, key: 'it_security.risk_mitigation_plan.status' }}
                /></td>
            </>
        )
    }

    const renderClients = (data, recSpan, backgroundColor, reference, show) => {
        return <DynamicClientCell clients={data} reference={reference} recSpan={recSpan} show={show} backgroundColor={backgroundColor} />
    }

    const renderMarketFlow = (rec, recSpan, backgroundColor, reference, show) => {
        return (
            <>
                {/* Product Market Plan */}
                {renderProductMarketPlan(rec.product_market_planning, recSpan, backgroundColor, reference, show)}
                {/* Communication Market Plan */}
                {renderCommuncationMarketPlan(rec.communication_market_planning, recSpan, backgroundColor, reference, show)}
                {/*  IT Security */}
                {renderITSecurity(rec.it_security, recSpan, backgroundColor, reference, show)}
            </>
        )
    }

    const renderProducts = () => {
        return business360Data.map((company, ci) => {
            const compSpan = getCompanyRowSpan(company);
            return company.products.map((prod, pi) => {
                const prodSpan = getProductRowSpan(prod);
                const backgroundColor = pi % 2 == 0 ? '#EFEFEF' : '#D7EAFF';
                return prod.opportunities.map((opp, oi) => {
                    const opperSpan = getOpportunityRowSpan(opp);
                    return opp.recommendations.map((rec, ri) => {
                        const subTasks = rec.showMore ? rec.sub_tasks : rec.sub_tasks?.slice(0, constant.default360SubTaskRowDisplay) || [];
                        const enableShowMore = rec.sub_tasks?.length > constant.default360SubTaskRowDisplay;
                        const recSpan = subTasks.length;
                        return subTasks.map((sub_task, ti) => {
                            return (
                                <tr key={`${ci}-${pi}-${oi}-${ri}-${ti}`}>
                                    {/******************** Innovation Flow ********************/}
                                    {/* Strategic Plan */}
                                    {pi === 0 && oi === 0 && ri === 0 && ti === 0 && (<td rowSpan={compSpan} style={{ backgroundColor: '#fff' }}>
                                        <EditableCell value={company.business_overview} reference={{ pi, key: 'business_overview' }} /></td>)}
                                    {oi === 0 && ri === 0 && ti === 0 && (<td rowSpan={prodSpan} style={{ backgroundColor }}>
                                        <EditableCell value={prod.name} reference={{ pi, key: 'name' }} enableHideShow enableDelete enableSort type={ADD_CELL_MODAL_TYPE.PRODUCT} show={prod.showchild} />
                                    </td>)}
                                    {ri === 0 && ti === 0 && (<td rowSpan={opperSpan} style={{ backgroundColor }}>
                                        <EditableCell value={opp.content} reference={{ pi, oi, key: 'content' }} enableHideShow enableDelete enableSort show={prod.showchild && opp.showchild} type={ADD_CELL_MODAL_TYPE.OPPERTUNITY} />
                                    </td>)}
                                    {ti === 0 && (<td rowSpan={recSpan} style={{ backgroundColor }}>
                                        <EditableCell value={rec.content} reference={{ pi, oi, ri, key: 'content' }} enableHideShow enableDelete enableSort show={prod.showchild && opp.showchild && rec.showchild} type={ADD_CELL_MODAL_TYPE.RECOMMENDATION} />
                                    </td>)}
                                    {/* Financials */}
                                    {ti === 0 && renderFinancials(rec.financial, recSpan, backgroundColor, { pi, oi, ri }, prod.showchild && opp.showchild && rec.showchild)}
                                    {/******************** Product Flow ********************/}
                                    {/* People Management */}
                                    {ti === 0 && renderPeopleManagement(rec.people_management, recSpan, backgroundColor, { pi, oi, ri }, prod.showchild && opp.showchild && rec.showchild)}
                                    {/* Development Plan */}
                                    {renderSubTasks(sub_task, backgroundColor, { pi, oi, ri, ti }, prod.showchild && opp.showchild && rec.showchild, enableShowMore && ti === 0)}
                                    {/******************** Market Flow ********************/}
                                    {ti === 0 && renderMarketFlow(rec, recSpan, backgroundColor, { pi, oi, ri }, prod.showchild && opp.showchild && rec.showchild)}
                                    {/******************** Customer Flow ********************/}
                                    {oi === 0 && ri === 0 && ti === 0 && renderClients(prod.clients || [], prodSpan, backgroundColor, { pi, oi, ri }, prod.showchild && opp.showchild && rec.showchild)}
                                </tr >
                            )
                        });
                    });
                })
            })
        });

    }

    return (
        <>
            <div className='resizable-table-container'>
                <table ref={tableRef} className="resizable-table mb-4">
                    {renderTableHeader()}
                    <tbody>{renderProducts()}</tbody>
                </table>
            </div>
            {renderRenderAddCellModal()}
        </>
    );
}

export default ResizableTable;


const getStatusColor = (status) => {
    const statusColorMap = {
        [BusinessStatus.DONE]: BusinessStatusColor.DONE,
        [BusinessStatus.PENDING]: BusinessStatusColor.PENDING,
        [BusinessStatus.ERROR]: BusinessStatusColor.ERROR,
    };

    return BusinessStatusColor.DEFAULT;
}

const DynamicClientCell = ({ clients, reference, backgroundColor, recSpan, show = true }) => {

    const [activeClient, setActiveClinet] = useState(null);
    const { business360EditMode } = useAppContext();
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        if (clients.length > 0) {
            setActiveClinet(clients[0].name);
        }
    }, [clients]);

    const renderHidShow = () => {
        if (business360EditMode) {
            const data = clients.find(c => c.name === activeClient);
            return (
                <FontAwesomeIcon style={{ top: 5, right: 30, cursor: 'pointer', position: 'absolute' }} icon={data.active ? faEye : faEyeSlash} className='text-grey' onClick={() => { onHideToggle() }} />
            )
        }
    }

    const renderClientList = () => {
        if (clients.length)
            return (
                <div className={`d-flex flex-column gap-1 align-items-baseline ${!show ? "editable-cell--disabled" : ""}`} >
                    {/* {renderHidShow()} */}
                    <div className="form-group mb-0">
                        <select className=""
                            style={{
                                borderRadius: 0,
                                border: 'none',
                                minWidth: 180,
                                backgroundColor,
                                padding: 5,
                                backgroundSize: 16
                            }}
                            value={activeClient}
                            onChange={(e) => setActiveClinet(e.target.value)}>
                            {clients.map((i, index) => <option value={i.name} key={`product-index-${index}`}>{i.name?.length > 18 ? `${i.name?.slice(0, 18)}...` : i.name}</option>)}
                        </select>
                    </div>
                </div>
            )
    }

    const onHideToggle = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }
    const renderClientDetails = () => {
        const ci = clients?.findIndex(c => c.name === activeClient);
        const data = clients?.find(c => c.name === activeClient);
        return (
            <>
                {/* Clients */}
                {<td rowSpan={recSpan} style={{ backgroundColor }}>{renderClientList()}</td>}
                {/* Lead Awareness */}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}> <EditableCell
                        value={data?.sales_funnel?.lead?.status} isStatus summary={data?.sales_funnel?.lead?.summary}
                        reference={{ ...reference, ci, key: 'sales_funnel.lead.status' }} show={show} /></td >
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.sales_funnel?.interest?.status} isStatus summary={data?.sales_funnel?.interest?.summary}
                        reference={{ ...reference, ci, key: 'sales_funnel.interest.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.sales_funnel?.decision?.status} isStatus summary={data?.sales_funnel?.decision?.summary}
                        reference={{ ...reference, ci, key: 'sales_funnel.decision.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.sales_funnel?.action?.status} isStatus summary={data?.sales_funnel?.action?.summary}
                        reference={{ ...reference, ci, key: 'sales_funnel.action.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.sales_funnel?.expand?.status} isStatus summary={data?.sales_funnel?.expand?.summary}
                        reference={{ ...reference, key: 'sales_funnel.expand.status' }} show={show} /></td>
                }
                {/* Delivery */}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.delivery?.delivery_approach?.status} isStatus summary={data?.delivery?.delivery_approach?.summary}
                        reference={{ ...reference, key: 'delivery.delivery_approach.status' }} show={show} /></td>
                }

                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.delivery?.resource_plan?.status} isStatus summary={data?.delivery?.resource_plan?.summary}
                        reference={{ ...reference, key: 'delivery.resource_plan.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.delivery?.schedule?.status} isStatus summary={data?.delivery?.schedule?.summary}
                        reference={{ ...reference, key: 'delivery.schedule.status' }} show={show} /></td >}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.delivery?.ship?.status} isStatus summary={data?.delivery?.ship?.summary}
                        reference={{
                            ...reference, key: 'delivery.ship.status'
                        }
                        } show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}> <EditableCell
                        value={data?.delivery?.deliver?.status
                        } isStatus summary={data?.delivery?.deliver?.summary}
                        reference={{
                            ...reference, key: 'delivery.deliver.status'
                        }} show={show} /></td >
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.delivery?.install?.status} isStatus summary={data?.delivery?.install?.summary}
                        reference={{ ...reference, key: 'delivery.install.status' }} show={show} /></td >
                }
                {/* Accounting  */}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }} > <EditableCell
                        value={data?.accounting?.invoice?.status} isStatus summary={data?.accounting?.invoice?.summary}
                        reference={{ ...reference, key: 'accounting.invoice.status' }} show={show} /></ td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.accounting?.processing?.status} isStatus summary={data?.accounting?.processing?.summary}
                        reference={{ ...reference, key: 'accounting.processing.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }} > <EditableCell
                        value={data?.accounting?.posting?.status} isStatus summary={data?.accounting?.posting?.summary}
                        reference={{ ...reference, key: 'accounting.posting.status' }} show={show} /></td>
                }
                {/* Customer Experience */}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.customer_experience?.journey_map?.status} isStatus summary={data?.customer_experience?.journey_map?.summary}
                        reference={{ ...reference, key: 'customer_experience.journey_map.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.customer_experience?.execute?.status} isStatus summary={data?.customer_experience?.execute?.summary}
                        reference={{ ...reference, key: 'customer_experience.execute.status' }} show={show} /></td>
                }
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }}><EditableCell
                        value={data?.customer_experience?.evolve?.status} isStatus summary={data?.customer_experience?.evolve?.summary}
                        reference={{ ...reference, key: 'customer_experience.evolve.status' }} show={show} /></td>
                }
                {/* Future Marketing */}
                {
                    <td rowSpan={recSpan} style={{
                        backgroundColor
                    }}><EditableCell
                            value={data?.future_plan?.plan?.status} isStatus summary={data?.future_plan?.plan?.summary}
                            reference={{
                                ...reference, key: 'future_plan.plan.status'
                            }
                            } show={show} /></td >}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }} > <EditableCell
                        value={data?.future_plan?.execute?.status} isStatus summary={data?.future_plan?.execute?.summary}
                        reference={{ ...reference, key: 'future_plan.execute.status' }} show={show} /></ td >}
                {
                    <td rowSpan={recSpan} style={{ backgroundColor }} > <EditableCell
                        value={data?.future_plan?.evolve?.status} isStatus summary={data?.future_plan?.evolve?.summary}
                        reference={{ ...reference, key: 'future_plan.evolve.status' }} show={show} /></ td>
                }
            </>
        )
    }
    return renderClientDetails();
}